module.exports = __webpack_public_path__ + "static/praise1.8fa70e4b0898f1e99c026f46d716ae64.png";